/* eslint-disable @typescript-eslint/naming-convention */
import pushClevertapEvent from '../pushClevertapEvent';

function getOutletsFromEmployee({ employee, outlets }) {
  const assignedOutletIds = {};
  employee.outlets.forEach((oid) => {
    assignedOutletIds[oid] = true;
  });
  const assignedOutlets: any[] = [];
  outlets.forEach((o) => {
    if (Object.prototype.hasOwnProperty.call(assignedOutletIds, o.id)) {
      assignedOutlets.push({ id: o.id, name: o.name });
    }
  });
  return assignedOutlets;
}

export function inviteStaff({ employee, outlets, role }) {
  const data = {
    Image: employee.photo_url,
    'First Name': employee.first_name,
    'Last Name': employee.last_name,
    Email: employee.email,
    'Phone Number': employee.phone,
    Role: role.name,
    PIN: employee.pin,
    Outlet: getOutletsFromEmployee({ employee, outlets }),
    Description: employee.description,
  };
  pushClevertapEvent('Invite New Staff', data);
}

export function editStaff({ employee, outlets, role }) {
  const data = {
    Image: employee.photo_url,
    'First Name': employee.first_name,
    'Last Name': employee.last_name,
    Email: employee.email,
    'Phone Number': employee.phone,
    Role: role.name,
    PIN: employee.pin,
    Outlet: getOutletsFromEmployee({ employee, outlets }),
    Description: employee.description,
  };
  pushClevertapEvent('Edit Staff', data);
}

export function deleteStaff({ employee }) {
  const assignedOutlets: any[] = [];
  employee.outlets.forEach((o) => {
    assignedOutlets.push({ id: o.id, name: o.name });
  });
  const data = {
    Image: employee.photo_url,
    'First Name': employee.first_name,
    'Last Name': employee.last_name,
    Email: employee.email,
    'Phone Number': employee.phone,
    Role: employee.role.name,
    PIN: employee.pin,
    Outlet: assignedOutlets,
    Description: employee.description,
  };
  pushClevertapEvent('Delete Staff', data);
}

export function clickAddStaffSlot() {
  pushClevertapEvent('Purchase Staff Slot Start');
}
